import SectionHeading from "@/components/base/SectionHeading";
import { brand, testimonials } from "@/mocks/site";

export default function Voices() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="读者反馈"
          title="把判断依据摊开，比一句“我信”更有用"
          description={`${brand.partnerCount} 位内容从业者与长期读者给了反馈，我们挑了几条放在这里。`}
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="border border-background-200 rounded-card bg-background-50 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                {item.text}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 font-heading text-sm font-bold">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}